import ProjectDescription from "./ProjectDescription";
import JournalDescription from "./JournalDescription";
import Social from "./Social";

export default {
  JournalDescription,
  ProjectDescription,
  Social
};
